"use client";

import { reminderNameNote } from "@/lib/sms-reminder-name-note";

type Props = {
  businessName: string | null | undefined;
  shopPhone?: string | null;
  /** Off where the sender fallback is already explained (the SMS settings phone preview). */
  includeSenderFallback?: boolean;
  className?: string;
};

/**
 * Non-blocking info note under a shop name field (and on the SMS settings card): shows how the
 * name will look in reminder texts when it would be shortened, or when texts come from Book4.
 * Renders nothing for a name that fits. Purely informational; it never stops a save.
 */
export function ReminderNameNote({ businessName, shopPhone, includeSenderFallback = true, className }: Props) {
  const note = reminderNameNote(businessName, shopPhone, { includeSenderFallback });
  if (!note) return null;
  return (
    <div
      role="note"
      data-testid="reminder-name-note"
      className={`mt-2 rounded-md border border-border bg-muted/40 px-3 py-2 text-xs text-muted-foreground ${className ?? ""}`}
    >
      <p>{note.message}</p>
      <p className="mt-1">
        Example reminder: <span className="text-foreground" data-testid="reminder-name-note-example">{note.example}</span>
      </p>
    </div>
  );
}
